import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

function removeEmptyValues(obj) {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    if (val) {
      acc[key] = val;
    }
    return acc;
  }, {});
}

export const routing = {
  router: historyRouter(),
  stateMapping: {
    stateToRoute(uiState) {
      return removeEmptyValues(uiState);
    },

    routeToState(routeState = {}) {
      return routeState;
    },
  },
};
